import { Hours } from './organization';
import { DirectoryLab, DirectoryPage } from 'components/supplier-browser/directory-browser-config';

/** DD-3696: the constructions a lab offers clinics (Lab settings → Available constructions). */
export const LAB_CONSTRUCTIONS = [
    'single_crown',
    'bridge',
    'implant_crown',
    'implant_bridge',
    'post',
    'complete_denture',
    'partial_denture',
    'temporary_denture',
    'bitetray',
] as const;

/** A lab in Find lab: its clinic-facing public profile, as a clinic sees it. */
export type LabDirectoryLab = DirectoryLab & {
    openingHours: Hours[];
};

export type LabDirectoryPage = DirectoryPage<LabDirectoryLab>;
